import { ButtonDesktop as Button } from '@alfa-bank/site-button-v2/desktop';
import { createWidget } from '@alfa-bank/site-util-create-widget';

import type { TArrow, TArrowDeps } from './models';
import styles from './styles.css';
import { FullHeightArrow as Component } from './full-height-arrow';
import { ArrowIcon } from './icons/arrow';

export const FullHeightArrowDesktop = createWidget<TArrowDeps, TArrow>({
    Button,
    styles,
    ArrowIcon,
})(Component);
